import * as accredibleCustomThemesMetadata from '../../../assets/themes/themes.json';

export { accredibleCustomThemesMetadata };
